<template>
  <!-- «Перейти к содержимому»: первый элемент в порядке Tab, виден только при
       фокусе с клавиатуры. -->
  <a
    href="#main"
    class="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[400] focus:px-4 focus:py-2 focus:bg-sheet focus:border focus:border-border focus:shadow-ink font-semibold"
    @click.prevent="toMain"
  >{{ $t('app.skipToContent') }}</a>
</template>

<script setup lang="ts">
// SPA с вкладками на v-show: обычный переход по якорю не переносит фокус
// в <main> надёжно, поэтому фокусируем явно.
const toMain = () => document.getElementById("main")?.focus();
</script>
